import { render, staticRenderFns } from "./door_plate_set.vue?vue&type=template&id=2e6054bb&scoped=true"
import script from "./door_plate_set.vue?vue&type=script&lang=js"
export * from "./door_plate_set.vue?vue&type=script&lang=js"
import style0 from "./door_plate_set.vue?vue&type=style&index=0&id=2e6054bb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6054bb",
  null
  
)

export default component.exports